import { Entity, Field } from 'typegraph';
class ObjStore{
	@Field()
	public id: number
	@Field()
    public data: Uint8Array
}
class File {
	@Field()
	public name: string;
	@Field()
    public url: string;
	@Field({ entity: ObjStore })
	public obj: ObjStore;
}
class Image {
	public id: number;
	@Field({ entity: File })
	public file: File

}
@Entity({one: "institution", many: "institutionsUser"})
export default class Institution {

	@Field()
	public id: number;

	@Field()
	public guid: string;

	@Field()
	public name: string;

	@Field({ entity: Image })
	public logo: Image;
}


@Entity({one: "objectFileById"})
export class ObjStoreFile {
	@Field()
	public data: string;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/institution.ts